<div [formGroup]="formGroupAttr">
  <input [formControl]="formControlAttr" type="text" [class]="className||'form-control'" [placeholder]="placeHolder"
    [matAutocomplete]="auto" matInput>
  <mat-autocomplete #auto>
    <mat-option *ngFor="let opt of optionList$|async" [value]="opt">{{opt}}</mat-option>
  </mat-autocomplete>
</div>